import React, { useState } from 'react';

const Context = React.createContext({});

// * Export the Context's Consumer.
export const { Consumer } = Context;

export const Provider = ({ children }) => {
    
    const toggleTab = (which) => {
        let newTabs = {
            wellness: "",
            metabolic: "",
            nutrition: "",
            personal: "",
        };
        newTabs[which] = "-active";
        updateState("servicesTabs", newTabs)
    };

    const clearCart = () => {
        console.log('clearing cart')
        setState(prev => ({
            ...prev,
            cart: []
        }))
    }

    const removeItem = id => {
        if (state.cart.length <= 1){ //If last item, clear storage first
            sessionStorage.setItem('cart', JSON.stringify([]))
        }
        setState(prev => ({
            ...prev,
            cart: prev.cart.filter((item, index) => index !== id),
        }))
    }

    const addToCart = (item) => {
        setState(prev => ({
            ...prev,
            cart: [...prev.cart, item]
        }))
    }

    const saveUserSession = (formData) =>{
        // console.log('Saving user data')
        sessionStorage.setItem('user', JSON.stringify(formData))
    }

    const checkSession = (newState) => {
        const sessionCart = JSON.parse(sessionStorage.getItem('cart'));
        // console.log('checkSession', sessionCart)
        if (state.cart.length < 1){
            // console.log('cart is empty', state.cart)
            //Cart is empty, check if session has data
            if (sessionCart?.length > 0){
                // console.log('sessionCart has items', sessionCart)
                updateState('cart', sessionCart) //If session cart has data, updateState
            } else{
                // console.log('Cart, and session both empty') //Do nothing
            }
            //
        } else {
            // console.log('cart is not empty', state.cart) //Save cart data to session (overwrite)
            sessionStorage.setItem('cart', JSON.stringify(state.cart))
        }

        const sessionUser = JSON.parse(sessionStorage.getItem('user'));
        // console.log('checkSession', sessionCart)
        if (!state.user?.first_name){
            // console.log('user is empty', state.user)
            //Cart is empty, check if session has data
            if (sessionUser?.first_name){
                // console.log('sessionUser has items', sessionUser)
                updateState('user', sessionUser) //If session user has data, updateState
            } else{
                // console.log('User, and session both empty') //Do nothing
            }
            //
        } else {
            // console.log('user is not empty', state.user) //Save user data to session (overwrite)
            sessionStorage.setItem('user', JSON.stringify(state.user))
        }

        const sessionApproved = JSON.parse(sessionStorage.getItem('approved'));
        if (!state.approved){
            // console.log('approved is false, checking session:', sessionApproved)
            //approved is false, check session
            if (sessionApproved){
                updateState('approved', true) //If session user has data, updateState
            } else{
                // console.log('User, and session both empty') //Do nothing
            }
        } else {
            // console.log('approved', state.approved) //Save approved to session (overwrite)
            sessionStorage.setItem('approved', JSON.stringify(state.approved))
        }
    }

    const updateState = (key, value) =>{
        // console.log("updateState", key, value)
        setState(prev => ({
            ...prev,
            [key]: value
        }))
    }

    const [ state, setState ] = useState({
        isAuthenticated: false,
        isLoading: false,
        error: null,
        approved: false,
        cart: [],
        user: {},
        userChoice: "",
        servicesTabs: {
            wellness: "-active",
            metabolic: "",
            nutrition: "",
            personal: "",
        },
        actions: {
            updateState,
            toggleTab,
            addToCart,
            removeItem,
            clearCart,
            saveUserSession
        }
    });

    checkSession(state)

    return (
        <Context.Provider value={state}>
            { children }
        </Context.Provider>
    )
}

/**
 * A higher-order component that wraps the provided component in a Context Consumer component.
 * @param {class} Component - A React component.
 * @returns {function} - A higher-order component.
 */

// * Export by default the withContext(Component) functiton.
// * This function allows other components (ex: Header, SignIn, SignOut, etc.) to access context.
export default function withContext(Component) {
    return function ContextComponent(props) {
      return (
        <Context.Consumer>
          {context => <Component {...props} context={context} />}
        </Context.Consumer>
      );
    }
}